import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import PageBreadcrumbsVariant, {PageBreadcrumbsVariantStyles} from "@WhiteCap/Components/PageBreadcrumbsVariant";
import * as React from "react";
import { FC } from "react";
import { css } from "styled-components";

export interface BreadcrumbsVariantStyles {
    pageBreadcrumbs?: PageBreadcrumbsVariantStyles;
}

export const breadcrumbVariantStyles: BreadcrumbsVariantStyles = {
    pageBreadcrumbs: {
        breadcrumbs: {
            css: css`
                padding-bottom: 30px;
            `,
        },
    },
};

export const Breadcrumbs: FC<WidgetProps> = () => {
    return <PageBreadcrumbsVariant extendedStyles={breadcrumbVariantStyles.pageBreadcrumbs} />;
};

const widgetModule: WidgetModule = {
    component: Breadcrumbs,
    definition: {
        group: "Basic",
		displayName: "Breadcrumb Variant",
        icon: "chevrons-right",
    },
};

export default widgetModule;
